import { B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID } from './b2bCopilotPlanDemo.js'
import { buildB2bCopilotPlanArtifactPayload } from './b2bCopilotPlanDemoContent.js'

/**
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function isB2bCopilotDevPlanArtifact(selection) {
  const name = String(selection?.fileName ?? '')
  return (
    selection?.artifactId === B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID ||
    name.includes('B2B Copilot') ||
    name.includes('b2b-copilot-dev-plan')
  )
}

/**
 * @param {string | undefined} artifactId
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 * @returns {import('@/features/documentPreview/documentPreviewTypes.js').GeneratedArtifactPreview}
 */
export function buildB2bCopilotDevPlanArtifact(artifactId, selection) {
  const id = artifactId || B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID
  return {
    artifactId: id,
    kind: 'doc',
    fileName: selection?.fileName ?? 'B2B Copilot — Development Plan.md',
    description: selection?.description ?? 'Markdown',
    payload: buildB2bCopilotPlanArtifactPayload(),
  }
}
